<template>
  <div class="nav-drawer">
    <v-navigation-drawer v-model="showDrawer" temporary app>
      <v-list>
        <v-list-item-group active-class="deep-purple--text text--accent-4">
          <v-list-item
            :to="{ name: 'ProjectsPage' }"
            v-if="userRole !== 'SEWING'"
          >
            <v-list-item-title>Fiches</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{ name: 'PlanningsPage' }"
            v-if="
              userRole == 'SUPER_ADMIN' ||
                userRole == 'ADMIN' ||
                userRole == 'CHIEF' ||
                userRole == 'SEWING'
            "
          >
            <v-list-item-title>Planning</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{ name: 'EditionsPage' }"
            v-if="userRole !== 'SEWING'"
          >
            <v-list-item-title>Editions</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{ name: 'SettingsPage' }"
            v-if="userRole !== 'SEWING'"
          >
            <v-list-item-title>Paramétrages</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{ name: 'DashboardPage' }"
            :disabled="appEnv != 'dev'"
            v-if="userRole !== 'SEWING'"
          >
            <v-list-item-title>Tableau de bord</v-list-item-title>
          </v-list-item>

          <!-- Debug -->
          <template v-if="appEnv == 'dev'">
            <v-list-item>
              <v-list-item-subtitle>Debug</v-list-item-subtitle>
            </v-list-item>

            <v-list-item :to="{ name: 'ConsultationPage' }">
              <v-list-item-title>Consultation</v-list-item-title>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>

      <div class="pa-2">
        Version : migration
        <!-- <v-btn v-if="!isAuthenticated" @click="checkUpdates" block>Check update</v-btn> -->
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: "NavDrawer",
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        showDrawer: this.show,

        appEnv: process.env.VUE_APP_ENV
      };
    },
    computed: {
      ...mapGetters({
        userRole: "user/userRole"
      })
    },
    watch: {
      show: function(value) {
        this.showDrawer = value;
      },

      showDrawer: function() {
        this.$emit("input", this.showDrawer);
      }
    },
    methods: {
      // Check updates
      checkUpdates() {
        let root = this;

        console.log("Checking updates....");

        navigator.serviceWorker
          .getRegistrations()
          .then(function(registrations) {
            for (var i = 0; i < registrations.length; i++) {
              console.log("registration found : asking for update");
              registrations[i].update();
            }
            root.$emit("input", false);
          });
      }
    }
  };
</script>

<style></style>
